import { normalizeConstructImage } from '../../../../../helpers/construct/page-content.helper';
import { convertToSplashAlignment, convertToSplashCTAStyle } from '../../../../../helpers/home/splash/splash.helper';
import { type ContentComponent, type HomePageAnimatedSplashContent } from '../../../../../types/construct.types';
import { AnimatedSplash } from '../../../../home-components/animated-splash/animated-splash.component';

export const AnimatedSplashHandler: ContentComponent<HomePageAnimatedSplashContent> = ({
	content: {
		fields: {
			media_image,
			fallback_image,
			mobile,
			media_video,
			ctaTitle,
			ctaSubtext,
			ctaStyle,
			alignment,
			link,
			backgroundTracking,
			buttonTracking,
			buttonText
		}
	}
}) => {
	const video = media_video?.items?.[0]?.detail?.video ?? null;

	return (
		<AnimatedSplash
			image={normalizeConstructImage(media_image)}
			fallbackImage={normalizeConstructImage(fallback_image)}
			video={video}
			mobileImage={normalizeConstructImage(mobile)}
			backgroundTracking={backgroundTracking ?? ''}
			animatedSplashCallToAction={{
				alignment: convertToSplashAlignment(alignment),
				link: {
					name: 'Link',
					url: link.linkUrl,
					tracking: link.trackingCode ?? ''
				},
				foregroundTracking: buttonTracking ?? '',
				text: buttonText ?? '',
				ctaTitle: ctaTitle ?? '',
				ctaSubtext: ctaSubtext ?? '',
				ctaStyle: convertToSplashCTAStyle(ctaStyle)
			}}
		/>
	);
};
